import { useMergedStyles } from 'hooks/useMergedStyles';
import { CopyToClipboard } from 'react-copy-to-clipboard/lib/Component';
import { Position, Tooltip } from 'react-tippy';

import { FC, ReactElement } from 'react';
import { Styles } from 'types/styles';
import styles from './TooltipComponent.module.scss';

type Props = {
  title?: string;
  disabled?: boolean;
  copy?: boolean;
  newStyles?: Styles;
  position?: Position;
  arrow?: boolean;
  html?: ReactElement;
  className?: string;
  theme?: string;
};
const TooltipComponent: FC<Props> = ({
  newStyles = {},
  title,
  disabled = false,
  copy = false,
  children,
  position = 'top',
  arrow = true,
  html,
  className,
  theme = '',
}) => {
  const mergedStyles = useMergedStyles(styles, newStyles);

  return (
    <div className={mergedStyles['tooltip-wrapper']}>
      <Tooltip
        title={title}
        position={position}
        trigger="mouseenter"
        hideOnClick={false}
        disabled={disabled}
        arrow={arrow}
        html={html}
        className={className}
        allowHTML
        interactive
        arrowSize="small"
        // open
        // @ts-ignore
        theme={theme}
      >
        {copy ? (
          <CopyToClipboard text={title}>
            <span>{children}</span>
          </CopyToClipboard>
        ) : (
          <span>{children}</span>
        )}
      </Tooltip>
    </div>
  );
};

export default TooltipComponent;
